import { FiGlobe, FiLayout, FiVolume1, FiImage } from 'react-icons/fi';
import { IconType } from 'react-icons';

export const MONITORING_LEVEL_SITE = 'SITE';
export const MONITORING_LEVEL_PLACEMENT = 'PLACEMENT';
export const MONITORING_LEVEL_AD = 'AD';
export const MONITORING_LEVEL_CREATIVE = 'CREATIVE';

export const MONITORING_TREE_LEVELS = [
  MONITORING_LEVEL_SITE,
  MONITORING_LEVEL_PLACEMENT,
  MONITORING_LEVEL_AD,
  MONITORING_LEVEL_CREATIVE,
] as const;

export type MonitoringTreeLevel = typeof MONITORING_TREE_LEVELS[number];

// Ikona per poziom drzewa, w tej samej kolejności co MONITORING_TREE_LEVELS —
// jedno miejsce, więc kolejność i ikony nie mogą się rozjechać.
export const MONITORING_LEVEL_ICONS: Record<MonitoringTreeLevel, IconType> = {
  [MONITORING_LEVEL_SITE]: FiGlobe,
  [MONITORING_LEVEL_PLACEMENT]: FiLayout,
  [MONITORING_LEVEL_AD]: FiVolume1,
  [MONITORING_LEVEL_CREATIVE]: FiImage,
};
